import AddIcon from '@mui/icons-material/Add';
import MenuIcon from '@mui/icons-material/Menu';
import {
  Box, Button,
  CircularProgress,
  Divider,
  Drawer,
  Grid,
  List,
  ListItemButton, ListItemIcon,
  ListItemText,
  TextField, Typography
} from '@mui/material';
import Alert from '@mui/material/Alert';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Snackbar from '@mui/material/Snackbar';
// import getConfig from "next/config";
// import Image from "next/image";
// import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import SuccessDialog from './components/SuccessDialog';

const api_host = `https://api.dev-agent.alpha-x-labs.com/repbe`

export const ProjectCreatePage = () => {
  const [workSpaceName, setWorkSpaceName] = useState([]);
  const dropdownOptions = {
    projectManagement: ['Jira', 'Jile'],
    chooseproject: workSpaceName,
    VersionControl: ['GitHub', 'GitLab', 'Bitbucket'],
    //designTemplate: ['SPRINGBOOT_DESIGN_TEMPLATE','PYTHON_DESIGN_TEMPLATE','REACT_DESIGN_TEMPLATE'],
    backend: ['SPRINGBOOT', 'PYTHON', 'REACT'],
    database: ['MongoDB', 'MySQL', 'PostgreSQL'],
    automation: ['Selenium'],
    performance: ['JMeter',],
    cloud: ['AWS', 'Azure', 'GCP'],
  };


//   const { publicRuntimeConfig } = getConfig();
//   const router = useRouter();

  const [openDrawer, setOpenDrawer] = useState(true);


  const [fieldError, setFieldError] = useState({})
  const [repoUrl, setRepoUrl] = useState()

  const initialForm = {
    repoName: '',
    "projectName": '',
    "TechStack": '',
    "Database": '',
    "Version Control": '',
    "Cloud": '',
    "Automation Tools": '',
    "Performance Tools": '',
    "Project Management": '',
    "projectArtifact": '',
    "instructions": ''
  }
  const [formData, setFormData] = useState(initialForm)

  useEffect(() => {
    console.log("inside the getworkspace")
    fetch(`${api_host}/api/v1/rapidengg/jile/getWorkspace`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ project_tool: formData["Project Management"] })
    })
      .then((res) => res.json())
      .then((res) => {
        if (res?.data?.workspaceList) {
          const name = res.data.workspaceList.map(ws => ws.workspaceName);
          console.log("type", typeof name, name)
          setWorkSpaceName(name)
        }
      })
      .catch((err) => {
        console.error('Error fetching workspaces:', err);
      });
  }, [formData["Project Management"]]);



  const handleChange = (e) => {
    console.log("inside handle", e.target.name)
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }))
    setFieldError((s) => ({ ...s, [e.target.name]: "" }))
    console.log(formData);
  }

  const handleCancel = () => {
    console.log("inside cancel")
    setFormData(initialForm)
    setRepoUrl("");
    setFieldError({});
    console.log(formData)
  }

  const handleSubmit = () => {
    console.log("inside handle submit");
    const newErrors = {};

    if (!formData.projectName.trim()) { newErrors.projectName = "Enter Project Name"; console.log("error"); setFieldError(newErrors); }
    if (!formData.repoName.trim()) { newErrors.repoName = "Enter Repo Name"; setFieldError(newErrors); }
    if (!formData["Project Management"].trim()) { newErrors["Project Management"] = "Select One"; setFieldError(newErrors); }
    // if (!formData.TechStack) { newErrors.TechStack = "Select Techstack"; setFieldError(newErrors); }
    if (!formData.Database) { newErrors.Database = "Select Database"; setFieldError(newErrors); }
    if (formData["Project Management"] === "Jira" && !formData["Choose Project"]) { newErrors["Choose Project"] = "Choose any project"; setFieldError(newErrors); }
    if (Object.keys(newErrors).length === 0) {
      console.log("insdie payload")
      const payload = {
        "repo_name": formData.repoName,
        "project_name": formData.projectName,
        "tech_stack_backend": formData.TechStack,
        "tech_stack_database": formData.Database,
        "project_management_tool": formData["Project Management"],
        "jile_project_name": formData["Choose Project"],
        "version_control": formData["Version Control"],
        "cloud": formData.Cloud,
        "testing_automation_tool": formData["Automation Tools"],
        "testing_perfomance_tool": formData["Performance Tools"],
        "project_artifact_registry": formData.projectArtifact,
        "other_instructions": formData.instructions

      }
      setIsLoading(true);

      fetch(`${api_host}/api/v1/rapidengg/cartridges/create_repo`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: 'include',
        referrerPolicy: "origin", // no-referrer, *no-referrer-when-downgrade, origin, 
        body: JSON.stringify(payload)
      }).then(r => r.json()).then(res => {

        setRepoUrl(res.web_url)
        setFormData({ ...initialForm })
        setSuccessDialogOpen(true);
        console.log("url ", res.web_url)
        // setOpen(true);
      }).finally(() => {
        setIsLoading(false)
        // setFormData(initialForm);
        // setFieldError({});
      })
    }
  }
  const [open, setOpen] = useState(false);
  const [successDialogOpen, setSuccessDialogOpen] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };


  return (
    <Box sx={{ display: 'flex' }}>
      <SuccessDialog
        successDialogOpen={successDialogOpen}
        setSuccessDialogOpen={setSuccessDialogOpen}
        primarySucessMessage={"Project created successfully"}
        secondarySucessMessage={"Your new project repository is ready and waiting for you."}
        urlLink={repoUrl}
        urlMessage={"You can access your repository here:"}
      />
      
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minHeight: "calc(100vh-64px)",
          backgroundColor: "white",
          px: 2, pt: 1,
          overflow: "hidden",
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <img
            src="/rapidengg/project_creation.svg"
            alt="Project Creation Icon"
            width={40}
            height={40}
            style={{ marginRight: 7 }} g
          />
          <Typography
            variant="h6"
            align="left"
            fontWeight="900"
            color="black"
            gutterBottom

          >
            Project Creation
          </Typography>
        </Box>

        <Box
          sx={{
            border: '1px solid #ccc', borderRadius: 2,
            padding: 2,
          }}>
          <Grid container spacing={2}>
            {/* Left Side - 70% */}
            <Grid item xs={12} md={8.4}>
              <Box sx={{ px: 1 }}>
                <Box mb={2} sx={{ width: '92%' }}>
                  <Typography sx={{ fontSize: '0.875rem', mb: 0.5 }}>
                    Project Name <sup style={{ color: 'red', marginLeft: '2px', fontSize: '1em' }}>*</sup>
                  </Typography>
                  <TextField
                    value={formData.projectName}
                    name='projectName'
                    onChange={handleChange} autoComplete='off'
                    variant="outlined"
                    size="small"
                    error={!!fieldError.projectName}
                    helperText={fieldError.projectName}
                    fullWidth
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        //'& fieldset': { borderColor: 'black' },
                        '&:hover fieldset': { borderColor: 'black' },
                        '&.Mui-focused fieldset': { borderColor: 'black' },
                      },
                    }}
                  />
                </Box>
                <Box mb={2} sx={{ width: '92%' }}>
                  <Typography sx={{ fontSize: '0.875rem', mb: 0.5 }}>
                    Project Context:
                  </Typography>
                  <TextField
                    value={formData.instructions}
                    name="instructions"
                    onChange={handleChange}

                    multiline
                    rows={3}
                    variant="outlined"
                    size="small"
                    fullWidth
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        //'& fieldset': { borderColor: 'black' },
                        '&:hover fieldset': { borderColor: 'black' },
                        '&.Mui-focused fieldset': { borderColor: 'black' },
                      },
                    }}
                  />
                </Box>
                <Box mb={2} sx={{ width: '92%' }}>
                  <Typography sx={{ fontSize: '0.875rem', mb: 0.5 }}>
                    Repo Name  <sup style={{ color: 'red', marginLeft: '2px', fontSize: '1em' }}>*</sup>
                  </Typography>
                  <TextField
                    variant="outlined"
                    size="small"
                    value={formData.repoName}
                    name='repoName'
                    onChange={handleChange}
                    error={!!fieldError.repoName}
                    helperText={fieldError.repoName}
                    autoComplete='off'
                    fullWidth
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        //'& fieldset': { borderColor: 'black' },
                        '&:hover fieldset': { borderColor: 'black' },
                        '&.Mui-focused fieldset': { borderColor: 'black' },
                      },
                    }}
                  />
                </Box>

                <Box mb={2} sx={{ width: '92%' }}>
                  <Typography sx={{ fontSize: '0.875rem', mb: 0.5 }}>
                    Project Artifact Registry
                  </Typography>
                  <TextField
                    value={formData.projectArtifact}
                    name="projectArtifact"
                    onChange={handleChange} autoComplete='off'
                    multiline
                    rows={1}
                    variant="outlined"
                    size="small"
                    fullWidth
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '&:hover fieldset': { borderColor: 'black' },
                        '&.Mui-focused fieldset': { borderColor: 'black' },
                      },
                    }}
                  />
                </Box>
              </Box>
            </Grid>
            {/* Right Side - 30% */}
            <Grid item xs={12} >
              <Box sx={{}}>
                {[

                  { label: 'TechStack', options: dropdownOptions.backend },
                  { label: 'Database', options: dropdownOptions.database },
                  { label: 'Version Control', options: dropdownOptions.VersionControl },
                  { label: 'Automation Tools', options: dropdownOptions.automation },
                  { label: 'Performance Tools', options: dropdownOptions.performance },
                  { label: 'Project Management', options: dropdownOptions.projectManagement },
                  { label: 'Cloud', options: dropdownOptions.cloud },
                ].map(({ label, options }) => (
                  <Box key={label} display="flex" alignItems="center" gap={1} mb={2}>
                    <Typography sx={{ minWidth: 160, fontSize: '0.875rem' }}>{label} {(
                      // label === "TechStack" ||
                      label === "Database" || label === "Project Management") && (<sup style={{ color: 'red', marginLeft: '2px', fontSize: '1em' }}>*</sup>)}
                    </Typography>

                    <Box sx={{ mt: '2px', width: '48%', flex: 1 }}>
                      <FormControl fullWidth
                      >
                        <TextField value={formData[label]}
                          name={label}
                          // error={(label === "TechStack" || label === "Database" || label === "Project Management") && !!fieldError[label]}
                          helperText={(label === "TechStack" || label === "Database" || label === "Project Management") && fieldError[label]}
                          onChange={(e) => { handleChange(e); }} select variant="outlined" size="small" fullWidth
                          sx={{
                            '& .MuiSelect-select': { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }
                          }}
                        >
                          {options.map((option) => (
                            <MenuItem key={option} value={option}>{option}</MenuItem>
                          ))}
                        </TextField>
                      </FormControl>

                    </Box>
                  </Box>
                ))}


                {formData["Project Management"] && (
                  <Box display="flex" alignItems="center" gap={1} mb={2}>
                    <Typography sx={{ minWidth: 160, fontSize: '0.875rem' }}>
                      Choose Project<sup style={{ color: 'red', marginLeft: '2px', fontSize: '1em' }}>*</sup>
                    </Typography>
                    <Box sx={{ mt: '2px', width: '48%', flex: 1 }}>
                      <FormControl fullWidth>
                        <TextField
                          value={formData["Choose Project"]}
                          name="Choose Project"
                          error={!!fieldError["Choose Project"]}
                          helperText={fieldError["Choose Project"]}
                          onChange={(e) => { handleChange(e); }} select variant="outlined" size="small" fullWidth
                          sx={{
                            '& .MuiSelect-select': { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }
                          }}
                        >
                          {dropdownOptions.chooseproject.map((option) => (
                            <MenuItem key={option} value={option}>{option}</MenuItem>
                          ))}
                        </TextField>
                      </FormControl>
                    </Box>
                  </Box>
                )}


                {/* <Box display="flex" alignItems="center" gap={1} mb={2}>
                  <Typography sx={{ minWidth: 160, fontSize: '0.875rem' }}>
                    Cloud
                  </Typography>
                  <Box sx={{ mt: '2px', width: '48%', flex: 1 }}>
                    <FormControl fullWidth>
                      <TextField
                        value={formData["Cloud"]}
                        name="Cloud"
                        onChange={(e) => { handleChange(e); }} select variant="outlined" size="small" fullWidth
                        sx={{
                          '& .MuiSelect-select': { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }
                        }}
                      >
                        {dropdownOptions.cloud.map((option) => (
                          <MenuItem key={option} value={option}>{option}</MenuItem>
                        ))}
                      </TextField>
                    </FormControl>
                  </Box>
                </Box> */}
                <Snackbar open={open} autoHideDuration={5000} onClose={handleClose} >
                  <Alert
                    onClose={handleClose}
                    severity="success"
                    variant="filled"
                    sx={{ width: '100%' }}
                  >
                    Project created successfully! You can access your repository here: {' '}
                    {/* <Link href={repoUrl} target="_blank" rel="noopener noreferrer" sx={{ color: '#fff', textDecoration: 'underline', fontWeight: 'bold' }} title={repoUrl}>
                      {repoUrl?.split('/').pop()}
                    </Link> */}
                  </Alert>
                </Snackbar>

              </Box>


            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" justifyContent="center" gap={2} mt={2}>
              <Button
                onClick={handleSubmit}
                disabled={isLoading}
                // disabled={isCreateDisabled}
                startIcon={isLoading ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : <AddIcon />}
                variant="contained"
                sx={{
                  bgcolor: '#000',
                  '&:hover': {
                    bgcolor: '#000'
                  },
                  color: '#fff',
                }}
              >
                CREATE
              </Button>
              <Button
                variant="outlined"
                sx={{
                  borderColor: '#ccc',
                  color: '#333',
                  borderRadius: '8px',
                  px: 4,

                }}
                onClick={handleCancel}

              >
                RESET
              </Button>
            </Box>
            {/* {repoUrl && <div style={{ display: "flex", justifyContent: "center", marginTop: "10px" }}>
              <Link component="button" onClick={() => window.open(repoUrl, "_blank")}>{`Click here to access the repository`}</Link>

            </div>} */}
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};


export default ProjectCreatePage;